import { Box, Button, Flex, Text } from '@mantine/core';
import Switch from 'react-switch';
import { LuRedo2, LuUndo2 } from 'react-icons/lu';
import { FaRegSave } from 'react-icons/fa';
import { FilterSelect } from '../FilterSelect';
import { useMemo } from 'react';
import { REPORT_TYPE_IDS } from '../../consts/v1/reportTypes';

export function Navbar({
  id,
  isViewer,
  handleChangeIsMultiFunds,
  isMultiFunds,
  undo,
  redo,
  canUndo,
  canRedo,
  isLockedPeriod,
  onSaveReport,
  reportTypes = [],
  currentReportType,
  onChangeReportType,
  hasChanges = false,
  funds,
  onChangeFundSelection,
  toggleComparisonMode,
  isComparisonMode,
  showComparisonReport,
  isMinimalFiling = false
}) {
  const visibleReportTypes = isMinimalFiling
    ? reportTypes.filter(item => item.id !== REPORT_TYPE_IDS.AIF002)
    : reportTypes;
  const fundOptions = useMemo(() => {
    return Object.values(funds).map(item => ({
      label: item.fund_name,
      value: item.fund_id,
      isSelected: item.isSelected
    }));
  }, [funds]);

  return (
    <Flex
      id={id ?? 'formpf-navbar'}
      align="center"
      p="16px"
      bg="white"
      sx={() => ({
        borderRadius: '4px',
        border: '1px solid #f1f3f5'
      })}
      justify="space-between"
    >
      <Flex>
        {visibleReportTypes.map(item => (
          <Box
            key={item.id}
            id={`formpf-navbar-report-type-${item.id}`}
            component="button"
            p="12px"
            c="black"
            fz="14px"
            lh="20px"
            sx={() => ({
              borderBottom:
                currentReportType === item.id ? '2px solid #228be6' : '2px solid #dee2e6',
              whiteSpace: 'no-wrap'
            })}
            onClick={() => onChangeReportType(item.id)}
          >
            {item.title}
          </Box>
        ))}
      </Flex>
      <Flex align="center" gap="16px">
        {currentReportType === REPORT_TYPE_IDS.AIF002 && !isMinimalFiling && (
          <FilterSelect
            options={fundOptions}
            title="All Funds"
            selectedTitle="fund"
            onChange={onChangeFundSelection}
          />
        )}
        {!isLockedPeriod && !isViewer && (
          <Button
            id="formpf-navbar-save-button"
            variant="subtle"
            leftSection={<FaRegSave />}
            onClick={onSaveReport}
            size="sm"
            disabled={!hasChanges}
          >
            Save
          </Button>
        )}

        {!isViewer && (
          <Flex align="center" gap="10px">
            <LuUndo2
              id="formpf-navbar-undo-button"
              fontSize="16px"
              onClick={undo}
              color={canUndo ? '#228be6' : '#909296'}
            />
            <LuRedo2
              id="formpf-navbar-redo-button"
              fontSize="16px"
              onClick={redo}
              color={canRedo ? '#228be6' : '#909296'}
            />
          </Flex>
        )}

        {showComparisonReport && (
          <Flex align="center" gap="10px">
            <Text id="formpf-navbar-comparison-label" fz="14px" lh="20px">
              Comparison Mode
            </Text>
            <Switch
              id="formpf-navbar-comparison-switch"
              uncheckedIcon={false}
              width={42}
              height={20}
              onChange={toggleComparisonMode}
              checkedIcon={false}
              handleDiameter={15}
              checked={isComparisonMode}
              onColor="#228be6"
              offColor="#E9ECEF"
            />
          </Flex>
        )}

        {currentReportType === REPORT_TYPE_IDS.AIF002 && !isMinimalFiling && (
          <Flex align="center" gap="10px">
            <Text id="formpf-navbar-multi-fund-label" fz="14px" lh="20px">
              Multi-Fund View
            </Text>
            <Switch
              id="formpf-navbar-multi-fund-switch"
              uncheckedIcon={false}
              width={42}
              height={20}
              onChange={handleChangeIsMultiFunds}
              checkedIcon={false}
              handleDiameter={15}
              checked={isMultiFunds}
              onColor="#228be6"
              offColor="#E9ECEF"
            />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}
